import * as types from '../actiontypes';
import {API_RESOURCES, createApiReadAction} from '../../util/api';
import env from '../../util/env';
import {serviceURL, promiseAreas} from '../../util/uiconstants';

export const getTrialBalance = (engagementId, queryString, includeArray, resolve = false) =>
	createApiReadAction(
		types.GET_TRIAL_BALANCE,
		{
			[API_RESOURCES.ENGAGEMENTS]: engagementId,
			[API_RESOURCES.TRIAL_BALANCE]: null
		},
		queryString,
		{includeArray},
		true,
		promiseAreas.GET_TRIAL_BALANCE,
		undefined,
		resolve
	);

export const getTrialBalanceById = (engagementId, trialBalanceId, queryparameters, includeArray, resolve = false) =>
	createApiReadAction(
		types.GET_TRIAL_BALANCE_BY_ID,
		{
			[API_RESOURCES.ENGAGEMENTS]: engagementId,
			[API_RESOURCES.TRIAL_BALANCE]: trialBalanceId
		},
		queryparameters,
		{includeArray},
		true,
		promiseAreas.GET_TRIAL_BALANCE_BY_ID,
		undefined,
		resolve
	);

export const getAdjustedTrialBalanceById = (engagementId, trialBalanceId, queryparameters, includeArray) =>
	createApiReadAction(
		types.GET_ADJUSTED_TRIAL_BALANCE_BY_ID,
		{
			[API_RESOURCES.ENGAGEMENTS]: engagementId,
			[API_RESOURCES.TRIAL_BALANCE]: trialBalanceId
		},
		queryparameters,
		{},
		true,
		undefined,
		includeArray,
		true
	);

export const modifyGLAccountDocument = (trialBalanceId, document, operation) => {
	return {
		type: types.MODIFY_GLACCOUNT_DOCUMENT,
		payload: {trialBalanceId, document, operation}
	};
};
export const resetFinancialStatementById = () => {
	return {
		type: types.CLEAR_FINANCIALSTATEMENT_BY_ID
	};
};

export const getFinancialStatementById = (url, finanacialStatementId, resolve = false) => {
	return {
		type: types.GET_FINANCIALSTATEMENT_BY_ID,
		meta: {
			api: {
				url,
				method: 'GET'
			}
		},
		finanacialStatementId,
		resolve
	};
};

export const updateTrialBalanceState = (data) => {
	return {
		type: types.CLEAR_TRIAL_BALANCE_DATA,
		data: data
	};
};

export const clearTrialBalanceState = (data) => {
	return {
		type: types.CLEAR_TRIAL_BALANCE_DATA,
		data: data
	};
};

export const postTrialBalanceData = (engagementId, data) => {
	const url = env.getBaseURL(serviceURL, engagementId) + 'trialbalances';

	return {
		type: types.POST_TRIAL_BALANCE_DATA,
		meta: {
			api: {
				url: url,
				method: 'POST',
				data: data
			},
			payload: data
		}
	};
};

export const deleteTrialBalance = (engagementId, trialBalanceId) => {
	const url = env.getBaseURL(serviceURL, engagementId) + 'trialbalances/' + trialBalanceId;

	return {
		type: types.DELETE_TRIAL_BALANCE,
		meta: {
			api: {
				url: url,
				method: 'DELETE'
			}
		}
	};
};

export const patchTrialBalance = (engagementId, trialBalanceId, trialBalanceData = undefined) => {
	const url = env.getBaseURL(serviceURL, engagementId) + 'trialbalances/' + trialBalanceId;

	if (!trialBalanceData) {
		trialBalanceData = [
			{
				op: 'add',
				path: '/TrialBalanceTypes/-',
				value: 3
			}
		];
	}

	return {
		type: types.PATCH_TRIAL_BALANCE,
		meta: {
			api: {
				url: url,
				method: 'PATCH',
				data: trialBalanceData
			},
			data: trialBalanceData
		}
	};
};

export const putTrialBalance = (engagementId, trialBalanceId, trialBalanceData = undefined) => {
	const url = env.getBaseURL(serviceURL, engagementId) + 'trialbalances/' + trialBalanceId;

	return {
		type: types.PUT_TRIAL_BALANCE,
		meta: {
			api: {
				url: url,
				method: 'PUT',
				data: trialBalanceData
			},
			data: trialBalanceData
		}
	};
};

export const setFinancialStatementMultipleMenuFilter = (filterKey, filters, value) => {
	return {
		type: types.SET_FINANCIAL_STATEMENT_MULTIPLE_MENU_FILTER,
		filterKey,
		filters,
		value
	};
};

export function clearFinancialStatementMenuFilters(filterKey, filterState = undefined) {
	return {
		type: types.CLEAR_FINANCIAL_STATEMENT_MENU_FILTERS,
		filterKey,
		filterState
	};
}

export const updateFinancialStatementState = (data) => {
	return {
		type: types.UPDATE_FINANCIALSTATEMENT_BY_ID,
		data
	};
};
